<div mat-dialog-title>
  <div>Update Reporting Period</div>
  <div (click)="onNoClick()" class="close-icon-container">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <form [formGroup]="updateForm">
    <mat-form-field class="full-width" subscriptSizing="dynamic">
      <mat-label>Folium ID</mat-label>
      <input formControlName="foliumId" matInput type="text" />
    </mat-form-field>
    <mat-form-field class="w-50-2" subscriptSizing="dynamic">
      <mat-label>Start Date</mat-label>
      <input disabled [value]="period.startDate" matInput type="text" />
    </mat-form-field>
    <div class="w-50-2">
      <fc-datepicker
        inputID="endDate"
        [datepickerFilter]="formatHelper.endDateFilter"
        formControlName="endDate"
        formFieldClass="w-100-1"
        required="true"
        label="RP End Date"></fc-datepicker>
    </div>
    <div class="w-50-2">
      <fc-datepicker
        required="false"
        formControlName="verificationDate"
        formFieldClass="w-100-1"
        inputID="verificationDate"
        label="Verification Date"></fc-datepicker>
    </div>
    <mat-form-field class="full-width" subscriptSizing="dynamic">
      <textarea matInput placeholder="Verification Notes" formControlName="verificationNotes" rows="3"></textarea>
    </mat-form-field>
    <div class="w-50-2">
      <fc-datepicker
        required="false"
        formControlName="issuanceDate"
        formFieldClass="w-100-1"
        inputID="issuanceDate"
        label="Issuance Date"></fc-datepicker>
    </div>

    <mat-form-field class="w-50-2" subscriptSizing="dynamic">
      <mat-label>Issuance</mat-label>
      <input formControlName="verificationIssuance" matInput placeholder="Issuance" type="text" />
    </mat-form-field>
    <div class="w-100-1">
      Vintage List:
    </div>
    @for (vintage of period.vintages; track $index) {
      <div class="w-20-3">
        {{ vintage.vintageYear }}:
      </div>
      <mat-form-field class="w-33-2" subscriptSizing="dynamic">
        <mat-label>Expected</mat-label>
        <input formControlName="vintage_{{vintage.vintageYear}}_expected" matInput placeholder="Expected Issuance"
               type="text" />
      </mat-form-field>
      <mat-form-field class="w-33-2" subscriptSizing="dynamic">
        <mat-label>Actual</mat-label>
        <input formControlName="vintage_{{vintage.vintageYear}}_actual" matInput placeholder="Actual Issuance"
               type="text" />
      </mat-form-field>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close]="false" color="primary" data-cy="button-cancel" mat-stroked-button>Cancel</button>
  <button
    (click)="onSubmit()"
    [disabled]="updateForm.invalid"
    color="primary"
    data-cy="button-submit"
    mat-raised-button>
    Save
  </button>
</div>
